/**
 * The app's loading indicator.
 *
 * Exists because ProtectedRoute was rendering Tailwind class names --
 * `animate-spin`, `text-gray-600`, `border-blue-600` -- in a project that has
 * never had Tailwind as a dependency. Every one of them was inert, so the
 * "checking authentication" state was unstyled text and a zero-height div: no
 * spinner, no colour, no layout. It looked like a design choice.
 *
 * `label` is announced to screen readers and shown beside the spinner when
 * `showLabel` is set. Callers pass translated text; nothing here is hardcoded
 * English, which the code this replaces also got wrong.
 */
export default function Spinner({ label, showLabel = false, size = 'md', center = false }) {
  const cls = ['spinner', `spinner--${size}`].join(' ')
  const body = (
    <span className="spinner-wrap">
      <span className={cls} role="status" aria-label={label} />
      {showLabel && label && <span className="spinner-label">{label}</span>}
    </span>
  )
  return center ? <div className="spinner-center">{body}</div> : body
}
